export default "__VITE_ASSET__D6zW5Km3__"